

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const TESTEMAILCONNECTION= createAsyncThunk(
  "testEmailConnection/testEmailConnection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const testEmailConnectionSlice = createSlice({
  name: "testEmailConnectionSlice",
  initialState: {
    testEmailConnection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOftestEmailConnection: (state) => {
        state.testEmailConnection.loading = false
        state.testEmailConnection.error = false
        state.testEmailConnection.data = []
        state.testEmailConnection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(TESTEMAILCONNECTION.fulfilled, (state, action) => {
      state.testEmailConnection = {
        ...state.testEmailConnection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(TESTEMAILCONNECTION.pending, (state, action) => {
      state.testEmailConnection = {
        ...state.testEmailConnection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(TESTEMAILCONNECTION.rejected, (state, action) => {
      state.testEmailConnection = {
        ...state.testEmailConnection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const testEmailConnectionAction = {
    TESTEMAILCONNECTION,
};

export { testEmailConnectionAction };
export default testEmailConnectionSlice.reducer;
export const {setInitialStateOftestEmailConnection} = testEmailConnectionSlice.actions
